import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FORM_PAGE_HEADER_MODE } from '../../directives/form-page-header-mode';

@Component({
  selector: 'app-form-page-heading',
  templateUrl: './form-page-heading.component.html',
  styleUrls: ['./form-page-heading.component.scss'],
  standalone: true,
  imports: [TranslateModule],
})
export class FormPageHeadingComponent {
  readonly mode = inject(FORM_PAGE_HEADER_MODE, { optional: true });
}
